// Georgian
export const ka = {
    weeklyRewards: 'კვირის ჯილდოები',
    days: 'დღე',
    hours: 'საათი',
    minutes: 'წთ',
    seconds: 'წმ',
    authenticating: 'ავთენტიფიკაცია',
    verifyWallet: 'გთხოვთ დაელოდოთ საფულის გადამოწმებას',
    authRequired: 'საჭიროა ავთენტიფიკაცია',
    dailyReward: 'ყოველდღიური ჯილდო',
    dailyRewardAvailable: 'ყოველდღიური ჯილდო ხელმისაწვდომია!',
    claimDailyReward: 'მიიღეთ ყოველდღიური ჯილდო',
    claiming: 'მიღება...',
    points: 'ქულები',
    rank: 'რანგი',
    of: '/',
    players: 'მოთამაშე',
    weeklyTopPlayers: 'კვირის საუკეთესო მოთამაშეები',
    thisWeekLeaderboard: 'ამ კვირის ლიდერბორდი',
    rankingsReset: 'რეიტინგი განახლდება ყოველ კვირას UTC-ის შუაღამისას',
    yourPoints: 'თქვენი ქულები',
    nextClaimAvailable: 'შემდეგი ჯილდო ხელმისაწვდომია:',
    multiplier: 'მამრავლი',
    bonusPointsMultiplier: 'ბონუს ქულების მამრავლი',
    outOf: '/',
    loading: 'იტვირთება...',
    errorLoading: 'შეცდომა ჩატვირთვისას',
    noEntries: 'ჩანაწერები არ არის',
    leaderboard: 'ლიდერბორდი',
    tasks: 'დავალებები',
    rules: 'წესები',
    profile: 'პროფილი',
    comingSoon: 'მალე...',
    yourStatsThisWeek: 'თქვენი სტატისტიკა ამ კვირაში',
    pointsMultiplier: 'ქულების გამრავლება',
    yourRank: 'თქვენი რანგი',
    rewards: 'ჯილდოები',
    daily: 'ყოველდღიური',
    weekly: 'ყოველკვირეული',
    claimRewards: 'ჯილდოების მიღება',
    copy: 'კოპირება',
    // Twitter Challenge
    twitterChallenge: 'Twitter გამოწვევა',
    connectTwitter: 'Twitter-ის დაკავშირება',
    twitterSuccess: '🎉 გილოცავთ! თქვენ ახლა იღებთ მუდმივ 10% ბონუსს ყველა ჯილდოზე!',
    twitterPrompt:
        'დააკავშირეთ თქვენი Twitter ანგარიში, რათა მიიღოთ მუდმივი 10% ბონუსი ყველა ჯილდოზე!',
    pleaseAddUserId: 'გთხოვთ დაამატოთ userId პარამეტრი URL-ში',
    emailChallengePrompt: 'გააზიარეთ თქვენი ელფოსტა, რათა მიიღოთ მუდმივი 10% ბონუსი ყველა ჯილდოზე!',
    emailChallengeSuccess: '🎉 დაკავშირებულია! თქვენ ახლა იღებთ მუდმივ 10% ბონუსს ყველა ჯილდოზე!',
    followKoalaWalletChallenge: 'მოგვყევით Twitter-ზე @coinomiWallet, რათა დაგვიჭიროთ მხარი!',
    twitterAuthSuccessTitle: 'Twitter წარმატებით დაკავშირებულია!',
    twitterAuthSuccessMessage:
        'თქვენ წარმატებით დააკავშირეთ თქვენი Twitter ანგარიში. შეგიძლიათ გააგრძელოთ აპის გამოყენება.',
    continueToApp: 'გაგრძელება აპში',
    twitter_like: 'Tweet-ს მოეწონა',
    twitter_retweet: 'Tweet გააზიარა',
    disconnect: 'გათიშვა',
    followCoinomiWallet: 'მოგვყევით Twitter-ზე @coinomiWallet, რომ დაგვიჭიროთ მხარი!',
    connectedBonus: '🎉 დაკავშირებულია! ახლა თქვენ იღებთ მუდმივ 10% ბონუსს ყველა ჯილდოზე!',
    shareVia: 'გაზიარება',
    shareOn: '{{network}}-ზე გაზიარება',
    shareInviteText:
        '🚀 მე ვიღებ უფასო კრიპტოვალუტას @CoinomiWallet-თან ერთად!\n\nჩამოტვირთეთ Coinomi მისამართიდან coinomi.com/downloads და შეიყვანეთ ჩემი რეკომენდაციის კოდი {{referralCode}}, რომ მიიღოთ ბონუსი აპში #Coinomi Rewards-ში გაწევრიანებისას.',
};
